import { render, staticRenderFns } from "./InitialAccess.vue?vue&type=template&id=6343e20c&"
import script from "./InitialAccess.vue?vue&type=script&lang=js&"
export * from "./InitialAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports